// ** React Imports
import { useState } from "react";

// ** MUI Components
import {
    IconButton,
    Button,
    Typography,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
  } from "@mui/material";
  import Grid from "@mui/material/Grid";
  import { useTheme } from "@mui/material/styles";

  // ** Custom Component Import
  import CustomTextField from "../../../components/mui/text-field";
  import CustomAvatar from "../../../components/mui/avatar";

  // ** Icon Imports
  import Icon from "../../../components/icon";
  import CheckIcon from '@mui/icons-material/Check';


  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  
  const MenuProps = {
    PaperProps: {
      style: {
        width: 250,
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
      }
    }
  }
  
  const names = [
    'Aiden Morgan',
    'Alexis Lee Harper',
    'Carlos Eduardo',
    'Henry John',
    'Omar Alexander',
    'Carlos Abbott',
    'Miriam Wagner',
    'Bradley Wilkerson',
    'Virginia Andrews',
    'Kelly Snyder'
  ]

const SendPortalInviteDialog = ({
    open,
    handleClose,
}) => {
    // ** Hooks
    const theme = useTheme();

    // ** States
    const [isEmpty, setIsEmpty] = useState(true);
    const [personName, setPersonName] = useState([]);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [invitationSent, setInvitationSent] = useState(false);

    const handleChange = event => {
        setPersonName(event.target.value)
    };

    const handleSendInvite = () => {
        setSelectedContacts(personName);
        if(selectedContacts.length === 0 ) {
            setInvitationSent(false);
        }else{
            setInvitationSent(true);
            setTimeout(() => {
                setInvitationSent(false);
                }, 5000);
        }
    };

    const handleSelectAll = (event) => {
        setSelectedContacts(names);
      };
    
      // Handle clearing all selections
      const handleClearAll = (event) => {
        setSelectedContacts([]);
      };

    return (
        <Dialog
        open={open}
        maxWidth='sm'
        fullWidth
        onClose={handleClose}
        PaperProps={{
            sx: {
              height: "100%", // Make the dialog take full screen height
              maxHeight: "70vh", // Set maximum height to 90% of the viewport height
            },
          }}
      >
        <DialogTitle 
            sx={{
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                borderBottom: '1px solid #D9D9D9', 
                paddingBottom: '20px !important'
            }}
        >
            <Typography variant='h4'>
                Send Customer Portal Invite
            </Typography>
            <IconButton onClick={handleClose}>
                <Icon icon='tabler:x' />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <Grid container spacing={5}>
                <Grid item xs={12}>
                   <Box sx={{
                     display: 'flex',
                     flexDirection: { xs: 'column', sm: 'row' }, 
                     alignItems: { xs: 'flex-start', sm: 'center' }, 
                       gap: { xs: 2, sm: 4 }, 
                          }}>
                        <CustomTextField
                            select
                            fullWidth
                            id='select-multiple-placeholder'
                            SelectProps={{
                            MenuProps,
                            multiple: true,
                            displayEmpty: true,
                            value: personName,
                            onChange: e => handleChange(e),
                            renderValue: selected => {
                                if (selected.length === 0) {
                                    return <span>Select contact</span>
                                }

                                return <span>{selected.length} {selected.length > 1 ? "Contacts " : "Contact "} Selected</span>
                            }
                            }}
                        >
                            <Box 
                                display="flex" 
                                alignItems='center' 
                                justifyContent='space-between'
                                ml={6}
                                mr={4}
                                my={4}
                            >
                                <Typography>{selectedContacts.length} Contacts Selected</Typography>
                                <Box display="flex" gap={4}>
                                    <Typography
                                        onClick={(e) => {
                                            handleSelectAll();
                                        }}
                                        sx={{
                                            cursor: "pointer",
                                            color: 'text.secondary',
                                            "&:hover": {
                                              color: "primary.main",
                                              textDecoration: "underline",
                                            },
                                          }}
                                    >
                                        Select All
                                    </Typography>
                                    <Typography
                                        onClick={(e) => {
                                            handleClearAll();
                                        }}
                                        sx={{
                                            cursor: "pointer",
                                            color: 'text.secondary',
                                            "&:hover": {
                                              color: "primary.main",
                                              textDecoration: "underline",
                                            },
                                          }}
                                    >
                                        Clear All
                                    </Typography>
                                </Box>
                            </Box>
                            {names.map(name => {
                                const initials = name.split(' ').map(n => n[0]).join('');
                                return (
                                    <MenuItem 
                                        key={name} 
                                        value={name}
                                        sx={{
                                            '&.Mui-selected': {
                                            backgroundColor: theme => `${theme.palette.info.light} !important`,
                                            color: theme => `${theme.palette.primary.main} !important`,
                                            }
                                        }}
                                    >   
                                        <CustomAvatar skin='light' color='info' size='small' sx={{ mr: 2 }}>
                                            {initials}
                                        </CustomAvatar>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant='body1'>{name}</Typography>
                                            <Typography variant='caption'>
                                                {name.toLowerCase().replace(/ /g, ".")}@gmail.com
                                            </Typography>
                                        </Box>
                                        {personName.includes(name) && (
                                            <CheckIcon sx={{ ml: 'auto', color: theme => theme.palette.info.main }} />
                                        )}
                                    </MenuItem>
                                )
                            })}
                        </CustomTextField>
                        <Button 
                            variant='contained' 
                            color='main' 
                            onClick={handleSendInvite} 
                            sx={{ whiteSpace: 'nowrap' }}
                        >
                            Send Invites
                        </Button>
                    </Box>
                </Grid>
                { selectedContacts.length === 0 && (
                    <Grid item xs={12}>
                        <Box sx={{ 
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                            transform: 'translate(0%, 50%)',
                            gap: 2,
                        }}>
                            <img src='/images/SendPortalInviteEmptyState.png' />
                            <Typography variant='h6'>No Invitations sent yet!</Typography>
                            <Typography variant='subtitle2'>Select the contacts and click 'Send Invite' to grant them portal access.</Typography>
                        </Box>
                    </Grid>
                )}
                <Grid item xs={12}>
                    { invitationSent && (
                        <Box 
                            sx={{ 
                                display: 'inline-flex', 
                                alignItems: 'center', 
                                backgroundColor: '#E0FAEC', 
                                px: 4, 
                                py: 2,
                                borderRadius: 1,
                                gap: 2,
                            }}
                        >
                            <Box 
                                sx={{
                                    color: 'success.main',
                                    display: 'flex',
                                    alignItems: 'center',
                                    m: 0,
                                    p: 0,
                                }}
                            >
                            <Icon icon="tabler:circle-check-filled" />
                            </Box>
                            <Typography>Invitations sent successfully!</Typography>
                        </Box>
                    )}
                </Grid>
                { selectedContacts != 0 &&(
                    <Grid item xs={12}>
                        <Typography variant='subtitle2'>Who has access</Typography>
                    </Grid>
                )}
                <Grid item xs={12}>
                    {selectedContacts.map(selectedContact => {
                        const initials = selectedContact.split(' ').map(n => n[0]).join('');
                        return (
                            <Box
                                key={selectedContact} 
                                sx={{ display: 'flex', alignItems: 'center', mb: 4 }}
                            >   
                                <CustomAvatar skin='light' color='info' size='small' sx={{ mr: 2 }}>
                                    {initials}
                                </CustomAvatar>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant='body1'>{selectedContact}</Typography>
                                    <Typography variant='caption'>
                                        {selectedContact.toLowerCase().replace(/ /g, ".")}@gmail.com
                                    </Typography>
                                </Box>
                                <Box sx={{display: 'flex', gap: 2, ml: 'auto'}}>
                                    <Button
                                        variant='outlined'
                                        size='small'
                                        startIcon={
                                            <Box sx={{color: 'success.main',
                                              display: 'flex',
                                              alignItems: 'center', // Centers icon vertically
                                              m: 0,
                                              p: 0,}}>
                                              <Icon icon='tabler:send' />
                                            </Box>
                                          }
                                    >
                                        Resend
                                    </Button>
                                    <Button 
                                        variant='outlined' 
                                        size='small'
                                        startIcon={
                                            <Box sx={{color: 'error.main',
                                              display: 'flex',
                                              alignItems: 'center', // Centers icon vertically
                                              m: 0,
                                              p: 0,}}>
                                              <Icon icon='tabler:trash' />
                                            </Box>
                                          }
                                    >Remove</Button>
                                </Box>
                            </Box>
                        )
                    })}
                </Grid>
            </Grid>
        </DialogContent>
      </Dialog>
    )
}

export default SendPortalInviteDialog